<div class="address-bar">
  <p data-testid="address">{{address}}</p>
</div>
